module.exports = __webpack_public_path__ + "images/icons/psp-car-storage-guide/10x35-car.svg";